(ns app.front.view.inspections.orders-section
  (:require [app.domain.inspection.model :as inspection-model]
            [app.domain.party.model :as party-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.file.upload :as upload]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.dnd :as dnd]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.inspections.acknowledge :as acknowledge]
            [app.front.view.inspections.deficiencies-v2 :as deficiencies-v2]
            [app.front.view.inspections.util :as insp-util]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [app.rich-text :as rich-text]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core :as rfc]
            [re-frame.core-instrumented :as rf]))


(def new-order-pseudo-id :new-order)


(def initial-state {:create-open?                                    false
                    :inspection.order/compliant-by-date              (js/Date.)
                    :inspection.order/additional-address-information ""
                    :inspection.order/deficiencies                   []})

(def dropdown-item-length 50)

(defn dropdown-text [get-text item]
  (str (subs (get-text item)
             0
             dropdown-item-length)
       " ("
       ((<sub [::date-util/date-fn]) (:entity/created item))
       ")"))

(rf/reg-sub
  ::inspection-id
  :-> ::inspection-id)


(rf/reg-sub
  ::creating-new-order?
  :<- [::new-order-data]
  :-> :create-open?)


(rf/reg-sub
  ::all-orders
  :<- [::entities/context]
  (fn [ctx [_ target-id]]
    (->> (entities/find-entities ctx
                                 {:entity/type   :entity.type/inspection-order
                                  :entity/parent target-id})
         (sort-by :inspection.order/compliant-by-date))))


(rf/reg-sub ::active-orders
  (fn [[_ target-id]]
    (rf/subscribe [::all-orders target-id]))
  (fn [all-orders _]
    (filter du/is-active? all-orders)))


(rf/reg-sub ::orders?
  (fn [[_ target-id]]
    (rf/subscribe [::active-orders target-id]))
  :-> (comp boolean seq))


(rf/reg-sub ::new-order-data
  :-> ::new-order)






(rf/reg-sub ::new-order-field
  :<- [::new-order-data]
  (fn [data [_ key]]
    (get data key)))


(defn- feature-ok? [data features feature-key data-key data-check-fn]
  (or (not (features feature-key))
      (data-check-fn (data-key data))))


(defn- invalid-order? [order-data features]
  (let [f-ok? (partial feature-ok? order-data features)]
    (if (and (-> order-data :inspection.order/issued-to seq)
             (-> order-data :inspection.order/order-template some?)
             (f-ok? :order.template.feature/linked-deficiencies :inspection.order/deficiencies not-empty)
             (f-ok? :order.template.feature/linked-orders :inspection.order/linked-orders not-empty)
             (f-ok? :order.template.feature/due-date :inspection.order/compliant-by-date inst?)
             (f-ok? :order.template.feature/other-items :inspection.order/other-items not-empty)
             (f-ok? :order.template.feature/notes :inspection.order/notes (complement ui-rt/empty-texts?)))
      false
      true)))

(defn- invalid-order-reason [order-data features]
  (let [f-ok? (partial feature-ok? order-data features)]
    (cond
      (-> order-data :inspection.order/issued-to seq empty?)
      :inspection.order-invalid/no-issued-to

      (-> order-data :inspection.order/order-template nil?)
      :inspection.order-invalid/no-template

      (not (f-ok? :order.template.feature/linked-deficiencies :inspection.order/deficiencies not-empty))
      :inspection.order-invalid/no-deficiencies

      (not (f-ok? :order.template.feature/linked-orders :inspection.order/linked-orders not-empty))
      :inspection.order-invalid/no-linked-orders

      (not (f-ok? :order.template.feature/due-date :inspection.order/compliant-by-date inst?))
      :inspection.order-invalid/no-due-date

      (not (f-ok? :order.template.feature/other-items :inspection.order/other-items not-empty))
      :inspection.order-invalid/no-other-items

      (not (f-ok? :order.template.feature/notes :inspection.order/notes (complement ui-rt/empty-texts?)))
      :inspection.order-invalid/no-notes

      :else nil)))

(rf/reg-sub ::editor-create-disabled?
  :<- [::new-order-data]
  :<- [::features new-order-pseudo-id]
  (fn [[order-data features] _]
    (invalid-order? order-data features)))

(rf/reg-sub ::order-edits-in-progress :-> ::order-edits-in-progress)

(rf/reg-sub ::order-editing-in-progress?
  :<- [::order-edits-in-progress]
  (fn [editing-map [_ order-id]]
    (boolean (some-> editing-map
                     (get order-id)
                     vals
                     seq))))

(rf/reg-sub ::invalid-order-reason
  (fn [[_ order-id]]
    [(rf/subscribe [::entities/entity-data order-id])
     (rf/subscribe [::features order-id])])
  (fn [[entity-data features] _]
    (invalid-order-reason entity-data features)))


(rf/reg-sub ::parties
  :<- [::entities/context]
  (fn [ctx [_ target-id]]
    (entities/find-entities ctx {:entity/parent target-id
                                 :domain/state  :party.state/active
                                 :entity/type   :entity.type/party})))


(rf/reg-event-db
  ::set-create-field
  (fn [db [_ key data]]
    (assoc-in db [::new-order key] data)))

(rf/reg-event-db
  ::set-edit-field
  (fn [db [_ id key data]]
    (assoc-in db [::edit-order id key] data)))


(rf/reg-event-db ::select-inspection
  (fn [db [_ inspection-id]]
    (assoc db ::inspection-id inspection-id)))


(rf/reg-event-db ::select-new-deficiency
  (fn [db [_ id deficiency-id]]
    (let [{:inspection.deficiency/keys
           [description
            description-from-order]
           :as deficiency}             (get-in db [::entities/entity-db deficiency-id])]
      (->> (select-keys deficiency
                        [:inspection.deficiency/description
                         :inspection.deficiency/required-action
                         :inspection.deficiency/comply-by-date])
           (merge {:db/id                                        deficiency-id
                   :inspection.deficiency/description-from-order (or description-from-order description)})
           (assoc-in db [::new-deficiency id])))))

(rf/reg-event-db ::select-linked-order
  (fn [db [_ order-id linked-order-id]]
    (assoc-in db [::new-linked-order order-id] {:db/id linked-order-id})))

(defn set-data-handler-fn [target]
  (fn [db [_ id key data]]
    (assoc-in db [target id key] data)))

(rf/reg-event-db ::set-new-deficiency-data
  (set-data-handler-fn ::new-deficiency))

(rf/reg-event-db ::set-other-item-data
  (set-data-handler-fn ::new-other-item))

(rf/reg-event-db
  ::close-editor
  (fn [db _]
    (assoc db ::new-order initial-state)))

(rf/reg-event-db
  ::initialize-new-order
  (fn [db _]
    (assoc db ::new-order initial-state)))

(rf/reg-event-fx ::trigger-add-order
  (fn [_ _]
    {:fx [[:dispatch [::initialize-new-order]]
          [:dispatch [::set-create-field :create-open? true]]
          [::futil/scroll-to-section :application-orders]]}))

(defn close-handler [target]
  (fn [db [_ order-id]]
    (update db target dissoc order-id)))

(defn open-handler [target]
  (fn [db [_ order-id]]
    (assoc-in db [target order-id :open?] true)))

(rf/reg-event-db ::close-deficiency-adding
  (close-handler ::new-deficiency))

(rf/reg-event-db ::open-deficiency-adding
  (open-handler ::new-deficiency))

(rf/reg-event-db ::close-linked-order-adding
  (close-handler ::new-linked-order))

(rf/reg-event-db ::open-linked-order-adding
  (open-handler ::new-linked-order))

(rf/reg-event-db ::close-other-item-adding
  (close-handler ::new-other-item))

(rf/reg-event-db ::open-other-item-adding
  (open-handler ::new-other-item))

(def interceptors [(rf/inject-cofx :tr)])

(defn link-added-handler-fn [close-handler notification-key]
  (fn [{:keys [tr]} [_ edited-order-id status resp]]
    (let [order-id (entities/id-of-some-in-apply-changes :entity.type/inspection-order resp)]
      {:dispatch-n [[::entities/apply-changes status resp]
                    [close-handler edited-order-id]
                    [:notifications/add :toast :success :success (tr [notification-key])]
                    [::deficiencies-v2/update-inspection-visit-result order-id]]})))


(rf/reg-sub
  ::inspections-raw
  :<- [::entities/context]
  (fn [ctx [_ target-id]]
    (->> (entities/find-entities ctx {:entity/type   :entity.type/inspection
                                      :entity/parent target-id})
         (sort-by :ordered/order <))))


(defn inspection-has-deficiencies? [inspection]
  (let [children (:entity/_parent inspection)]
    (some #(= (:entity/type %) :entity.type/inspection-deficiency) children)))


(rf/reg-sub
  ::inspections-with-deficiencies
  (fn [[_ target-id]]
    (rf/subscribe [::inspections-raw target-id]))
  (fn [inspections _]
    (filter inspection-has-deficiencies? inspections)))


(rf/reg-sub
  ::all-deficiencies
  :<- [::entities/context]
  :<- [::inspection-id]
  (fn [[ctx inspection-id] _]
    (->> (entities/find-entities ctx
                                 {:entity/type   :entity.type/inspection-deficiency
                                  :entity/parent inspection-id})
         (filter du/is-active?))))


(rf/reg-sub
  ::deficiencies
  :<- [::all-deficiencies]
  (fn [all _]
    (->> all
         (filter #(-> % :domain/state (not= :inspection.deficiency.state/cleared)))
         (sort-by (juxt (du/state-order-fn inspection-model/deficiency-states-order)
                        :inspection.deficiency/remark?
                        :entity/created)))))



;; Returns deficiencies that are not tied to an active order
(rf/reg-sub
  ::available-deficiencies
  (fn [[_ target-id]]
    [(rf/subscribe [::active-orders target-id])
     (rf/subscribe [::deficiencies])
     (rf/subscribe [::new-order-data])])
  (fn [[orders deficiencies new-order-data] _]
    (let [deficiencies-from-active-orders (->> orders
                                               (mapcat :inspection.order/deficiencies)
                                               set)
          new-order-selected-deficiencies (set (map :db/id (:inspection.order/deficiencies new-order-data)))]
      ;; filter also the deficiencies that are added ito a new order, not yet sent to backend
      (->> (set/difference (set deficiencies) deficiencies-from-active-orders)
           (filter #(not (contains? new-order-selected-deficiencies (:db/id %))))))))


(defn open-handler-fn [key]
  (fn [db [_ order-id]]
    (not (nil? (get-in db [key order-id])))))


(rf/reg-sub ::deficiency-adding-open?
  (open-handler-fn ::new-deficiency))


(rf/reg-sub ::linked-order-adding-open?
  (open-handler-fn ::new-linked-order))


(rf/reg-sub ::other-item-adding-open?
  (open-handler-fn ::new-other-item))


(defn order-signal-and-handler [key]
  [(fn [[_ order-id]]
     [(rf/subscribe [::entities/entity-db])
      (rf/subscribe (if (= new-order-pseudo-id order-id)
                      [::new-order-field key]
                      [::get-edit-field order-id key]))])
   (fn [[edb edit-value] [_ order-id]]
     (or edit-value
         (-> edb
             (get order-id)
             key)))])

(apply rfc/reg-sub ::issued-to
       (order-signal-and-handler :inspection.order/issued-to))

(rf/reg-sub ::issued-to-entities
  (fn [[_ order-id]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::issued-to order-id])])
  (fn [[ctx issued-to] _]
    (when (seq issued-to)
      (entities/find-entities ctx issued-to))))


(rf/reg-sub ::order-other-item-entities
  (fn [[_ order-id]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::order-other-items order-id])])
  (fn [[ctx items] _]
    (->> items
         (map (fn [item]
                ;; entity, if already exists
                (or (entities/find-entity ctx item)
                    ;; when creating new order, the data is contained here
                    item)))
         (sort-by :ordered/order))))


(rf/reg-sub ::linked-order-ids
  (fn [[_ order-id]]
    (rf/subscribe [::linked-orders order-id]))
  (fn [orders _]
    (->> orders (map :db/id) set)))


(rf/reg-sub ::linked-order-entities
  (fn [[_ order-id]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::linked-orders order-id])])
  (fn [[ctx orders] _]
    (->> orders
         (map (partial entities/find-entity ctx))
         (sort-by :entity/created))))


(rf/reg-sub ::features
  (fn [[_ order-id]]
    [(rf/subscribe [::order-template-entities])
     (rf/subscribe [::template order-id])])
  (fn features-handler [[templates template] _]
    (-> templates
        (p/find-first {:db/id template})
        :order.template/features
        (or #{}))))


(rf/reg-sub
  ::get-edit-field
  (fn [db [_ id key]]
    (get-in db [::edit-order id key])))






(rf/reg-sub ::get-new-deficiency-data
  (fn [db [_ id key]]
    (get-in db [::new-deficiency id key])))


(rf/reg-sub ::get-other-item-data
  (fn [db [_ id key]]
    (get-in db [::new-other-item id key])))


(rf/reg-sub ::new-linked-order-all
  :-> ::new-linked-order)

(rf/reg-sub ::new-linked-order
  :<- [::new-linked-order-all]
  (fn [linked-orders [_ order-id]]
    (get linked-orders order-id)))

(rf/reg-sub ::new-linked-order-entity
  (fn [[_ order-id]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::new-linked-order order-id])])
  (fn [[ctx linked-order-id] _]
    (entities/find-entity ctx linked-order-id)))


(apply rfc/reg-sub ::compliant-by-date
       (order-signal-and-handler :inspection.order/compliant-by-date))

(apply rfc/reg-sub ::address-info
       (order-signal-and-handler :inspection.order/additional-address-information))

(apply rfc/reg-sub ::template
       (order-signal-and-handler :inspection.order/order-template))

(apply rfc/reg-sub ::linked-orders
       (order-signal-and-handler :inspection.order/linked-orders))

(apply rfc/reg-sub ::order-other-items
       (order-signal-and-handler :inspection.order/other-items))

(apply rfc/reg-sub ::notes
       (order-signal-and-handler :inspection.order/notes))




(rf/reg-sub ::order-template-entities
  :<- [::ws-subs/entities-for-group]
  (fn [entities [_ target]]
    (->> entities
         (filter inspection-model/is-order-template?)
         (filter (partial inspection-model/order-template-applicable-to-target? target))
         (filter du/is-active?))))


(rf/reg-event-fx ::deficiency-added
  interceptors
  (link-added-handler-fn ::close-deficiency-adding
                         :order/deficiency-added))

(rf/reg-event-fx ::linked-order-added
  interceptors
  (link-added-handler-fn ::close-linked-order-adding
                         :order/linked-order-added))

(rf/reg-event-fx ::other-item-added
  interceptors
  (link-added-handler-fn ::close-other-item-adding
                         :order/other-item-added))

(rf/reg-event-fx ::link-removed
  interceptors
  (fn [{:keys [tr]} [_ notification status resp]]
    (let [order-id (entities/id-of-some-in-apply-changes :entity.type/inspection-order resp)]
      {:dispatch-n [[::entities/apply-changes status resp]
                    [:notifications/add :toast :success :success (tr [notification])]
                    [::deficiencies-v2/update-inspection-visit-result order-id]]})))

(rf/reg-event-fx
  ::order-created
  interceptors
  (fn [{:keys [tr]} [_ status resp]]
    (let [order-id (entities/id-of-some-in-apply-changes :entity.type/inspection-order resp)]
      {:dispatch-n [[::entities/apply-changes status resp]
                    [::close-editor]
                    [:notifications/add :toast :success :success (tr [:deficiencies/new-order-created])]
                    [::deficiencies-v2/update-inspection-visit-result order-id]]})))

(rf/reg-event-fx ::order-changes-saved
  interceptors
  (fn [_ [_ status resp]]
    (let [order-id (entities/id-of-some-in-apply-changes :entity.type/inspection-order resp)]
      {:dispatch-n [[::entities/apply-changes status resp]
                    [::deficiencies-v2/update-inspection-visit-result order-id]]})))

(rf/reg-event-db ::order-changes-done
  (fn [db [_ order-id data-key]]
    (-> db
        (p/dissoc-in [::order-edits-in-progress order-id data-key]))))

(rf/reg-event-fx
  ::order-removed
  interceptors
  (fn [{:keys [tr]} [_ status resp]]
    (let [order-id (entities/id-of-some-in-apply-changes :entity.type/inspection-order resp)]
      {:dispatch-n [[::entities/apply-changes status resp]
                    [:notifications/add :toast :success :success (tr [:deficiencies/order-removed])]
                    [::deficiencies-v2/update-inspection-visit-result order-id]]})))

(rf/reg-event-fx
  ::order-issued
  interceptors
  (fn [{:keys [tr]} [_ status resp]]
    (let [order-id (entities/id-of-some-in-apply-changes :entity.type/inspection-order resp)]
      {:dispatch-n [[::entities/apply-changes status resp]
                    [:notifications/add :toast :success :success (tr [:changes-saved])]
                    [::deficiencies-v2/update-inspection-visit-result order-id]]})))

(def deficiency-store-attrs [:inspection.deficiency/required-action
                             :inspection.deficiency/description-from-order
                             :inspection.deficiency/comply-by-date
                             :db/id])

(defn- create-order-command [db target-id key]
  (let [{:inspection.order/keys
         [deficiencies
          linked-orders
          other-items]
         :as
         data}                  (get db key)
        payload                 (-> data
                                    (select-keys [:inspection.order/order-template
                                                  :inspection.order/issued-to
                                                  :inspection.order/compliant-by-date
                                                  :inspection.order/additional-address-information
                                                  :inspection.order/notes
                                                  :id])
                                    (merge {:deficiencies  (->> deficiencies
                                                                (map #(select-keys % deficiency-store-attrs)))
                                            :linked-orders linked-orders
                                            :other-items   other-items}))]
    {:comm/command {:command    :process/apply-signal
                    :data       {:entity-id      target-id
                                 :process/signal [:process.signal/create-inspection-order payload]}
                    :on-success [::order-created]}}))

(rf/reg-event-fx ::set-order-field
  (fn [{:keys [db]} [_ order-id target-id data-key data]]
    {:db                (-> db (assoc-in [::order-edits-in-progress order-id data-key] true))
     :dispatch          [::set-edit-field order-id data-key data]
     :dispatch-debounce [{:id      [::edit-order order-id data-key]
                          :timeout 500
                          :action  :dispatch
                          :event   [::store-order-field order-id target-id data-key data]}]}))

(rf/reg-event-fx ::clear-order
  (fn [_ [_ order-id target-id]]
    (let [payload {:id order-id}
          command {:command    :process/apply-signal
                   :data       {:entity-id      target-id
                                :process/signal [:process.signal/clear-inspection-order payload]}
                   :on-success [::order-changes-saved]
                   :on-done    [::order-changes-done order-id nil]}]
      {:comm/command command})))

(rf/reg-event-fx ::store-order-field
  (fn [_ [_ order-id target-id data-key data]]
    {:dispatch [::process/signal
                target-id
                [:process.signal/edit-inspection-order {data-key data
                                                        :id      order-id}]
                {:on-success [::order-changes-saved]
                 :on-done    [::order-changes-done order-id data-key]}]}))

(rf/reg-event-fx
  ::remove-order
  (fn [_ [_ target-id id]]
    {:comm/command {:command    :process/apply-signal
                    :data       {:entity-id      target-id
                                 :process/signal [:process.signal/remove-inspection-order
                                                  {:id id}]}
                    :on-success [::order-removed]}}))

(rf/reg-event-fx
  ::issue-order
  (fn [_ [_ target-id id]]
    {:comm/command {:command    :process/apply-signal
                    :data       {:entity-id      target-id
                                 :process/signal [:process.signal/issue-inspection-order
                                                  {:id id}]}
                    :on-success [::order-issued]}}))

(rf/reg-event-fx ::create
  (fn [{:keys [db]} [_ target-id]]
    (create-order-command db target-id ::new-order)))

(defn add-handler [db-location attr on-local-done on-server-done signal & [get-additional-params]]
  (fn [{:keys [db]} [_ target-id order-id thing-id & additional-params]]
    ;; If deficiency is added to a new order just move it in the app-db
    (if (= order-id new-order-pseudo-id)
      (let [old-contents (get-in db [::new-order attr])]
        {:db       (assoc-in db
                             [::new-order attr]
                             (conj old-contents (get-in db [db-location new-order-pseudo-id])))
         :dispatch [on-local-done order-id]})
      {:comm/command {:command    :process/apply-signal
                      :data       {:entity-id      target-id
                                   :process/signal [signal
                                                    (merge {:id  order-id
                                                            :add thing-id}
                                                           (when get-additional-params
                                                             (get-additional-params additional-params)))]}
                      :on-success [on-server-done order-id]}})))

(rf/reg-event-fx ::add-deficiency
  (add-handler ::new-deficiency
               :inspection.order/deficiencies
               ::close-deficiency-adding
               ::deficiency-added
               :process.signal/edit-inspection-order-deficiencies
               (fn [[deficiency-description deficiency-required-action]]
                 (p/assoc-if {}
                             :description deficiency-description
                             :required-action deficiency-required-action))))

(rf/reg-event-fx ::add-linked-order
  (add-handler ::new-linked-order
               :inspection.order/linked-orders
               ::close-linked-order-adding
               ::linked-order-added
               :process.signal/edit-inspection-order-linked-orders))

(rf/reg-event-fx ::add-other-item
  (fn [{:keys [db]} [_ target-id order-id description reference]]
    ;; If deficiency is added to a new order just move it in the app-db
    (if (= order-id new-order-pseudo-id)
      (let [old-contents (get-in db [::new-order :inspection.order/other-items])
            order-nr     (or (some->> old-contents
                                      (keep :ordered/order)
                                      seq
                                      (apply max)
                                      inc)
                             0)
            content      (-> db
                             (get-in [::new-other-item new-order-pseudo-id])
                             (select-keys [:inspection.order.other/description
                                           :inspection.order.other/reference])
                             (assoc :ordered/order order-nr))]
        {:db       (assoc-in db
                             [::new-order :inspection.order/other-items]
                             (conj old-contents content))
         :dispatch [::close-other-item-adding order-id]})
      {:comm/command {:command    :process/apply-signal
                      :data       {:entity-id      target-id
                                   :process/signal [:process.signal/edit-inspection-order-other-items
                                                    {:id  order-id
                                                     :add (p/assoc-if
                                                            {}
                                                            :inspection.order.other/description description
                                                            :inspection.order.other/reference reference)}]}
                      :on-success [::other-item-added order-id]}})))

(defn unlink-handler-fn [key signal notify-on-success]
  (fn [{:keys [db]} [_ target-id order-id linked-id]]
    (if (= order-id new-order-pseudo-id)
      {:db (->> (get-in db [::new-order key])
                (filter #(not= linked-id (:db/id %)))
                (assoc-in db [::new-order key]))}
      {:comm/command {:command    :process/apply-signal
                      :data       {:entity-id      target-id
                                   :process/signal [signal {:id     order-id
                                                            :remove linked-id}]}
                      :on-success [::link-removed notify-on-success]}})))

(rf/reg-event-fx ::unlink-order
  (unlink-handler-fn :inspection.order/linked-orders
                     :process.signal/edit-inspection-order-linked-orders
                     :order/linked-order-removed))

(rf/reg-event-fx ::unlink-deficiency
  (unlink-handler-fn :inspection.order/deficiencies
                     :process.signal/edit-inspection-order-deficiencies
                     :order/deficiency-removed))

(rf/reg-event-fx ::remove-other-item
  (fn [{:keys [db]} [_ target-id order-id linked-id-or-nr]]
    (if (= order-id new-order-pseudo-id)
      {:db (-> db
               (update-in [::new-order :inspection.order/other-items]
                          (partial filter #(not= linked-id-or-nr (:ordered/order %)))))}
      {:comm/command {:command    :process/apply-signal
                      :data       {:entity-id      target-id
                                   :process/signal [:process.signal/edit-inspection-order-other-items
                                                    {:id     order-id
                                                     :remove linked-id-or-nr}]}
                      :on-success [::link-removed :order/other-item-removed]}})))

(defn- column-content [header value & [required?]]
  [:div.flex-1.flex.flex-col.justify-between
   [:div.text-xs {:class (when required? "required-field")} header]
   [:div.pb-3.my-2 value]])

(defn- render-compliant-by-date-picker [tr date callback-fn editable?]
  (if editable?
    [:div.required-input
     [ui/date-picker {:id         "compliant-by-date"
                      :class-name "full-width-select"
                      :callback   callback-fn
                      :label-text (tr [:inspection/must-be-compliant-by])
                      :value      date
                      :min-date   (js/Date.)}]]
    [column-content (tr [:inspection/must-be-compliant-by]) ((<sub [::date-util/date-fn]) date)]))


(defn- render-additional-address-information-text-field [tr address-info on-change-fn editable?]
  (if editable?
    (cc/text-input {:id         "additional-address-information"
                    :label-text (tr [:inspection/additional-address-information])
                    :value      address-info
                    :on-change  on-change-fn})
    [column-content (tr [:inspection/additional-address-information]) address-info]))

(defn subtle-button [{:keys [event]} content]
  [:button.mr-2.bg-transparent.border-0.text-blue-600.text-sm
   {:on-click #(>evt event)}
   content])

(defn add-buttons [{:keys [cancel-evt add-evt disabled?]}]
  (let [tr (<sub [:tr])]
    [:div.flex.justify-end
     [ui-action-buttons/save-cancel-buttons
      (util/mmap {:on-cancel      #(>evt cancel-evt)
                  :on-save        #(>evt add-evt)
                  :save-disabled? disabled?
                  :size           :small}
                 tr)]]))

(defn add-container [{:keys [title] :as props} & contents]
  (-> [:div.p-4.border.border-solid.border-gray-400.bg-gray-200.mb-4.animation-appear-slide-down
       [:header.mb-4.flex.justify-between
        [:h2.mb-0.text-base title]]]
      (into contents)
      (into [[add-buttons (select-keys props [:cancel-evt :add-evt :disabled?])]])))

(defn get-deficiency-description [deficiency]
  (rich-text/join-rich-text-content
    (or (:inspection.deficiency/description-from-order deficiency)
        (:inspection.deficiency/description deficiency))))

(defn- add-deficiencies [tr order-id target-id auth-group]
  (let [selected                   (<sub [::get-new-deficiency-data order-id :db/id])
        deficiency-description     (<sub [::get-new-deficiency-data order-id :inspection.deficiency/description-from-order])
        deficiency-required-action (<sub [::get-new-deficiency-data order-id :inspection.deficiency/required-action])
        inspections                (<sub [::inspections-with-deficiencies target-id])
        selected-inspection        (<sub [::inspection-id])
        available-deficiencies     (<sub [::available-deficiencies target-id])
        disabled?                  (or (not selected)
                                       (= (str selected) "none"))
        lang                       (<sub [:language])]
    [add-container {:title      (tr [:deficiencies/add-new])
                    :cancel-evt [::close-deficiency-adding order-id]
                    :add-evt    [::add-deficiency
                                 target-id
                                 order-id
                                 selected
                                 deficiency-description
                                 deficiency-required-action]
                    :disabled?  disabled?}
     [:div.mb-6
      [:div.flex.flex-col.lg:flex-row
       [:div.flex.md:mr-4.required-input.flex-col.lg:flex-row
        (cc/select
          {:id         "inspection-select"
           :label-text (tr [:deficiencies/select-inspection])
           :value      (str selected-inspection)
           :on-change  #(>evt [::select-inspection (-> % futil/tval futil/parse-int)])
           :class-name "mb-6 md:mr-4"}
          [ui/placeholder-select-item tr :none]
          (futil/for-frag [inspection inspections]
            (cc/select-item {:text  (inspection-model/inspection-name inspection lang)
                             :value (:db/id inspection)})))
        (cc/select
          {:id         "new-deficiency-select"
           :label-text (tr [:deficiencies/select-new-deficiency])
           :value      (str selected)
           :on-change  #(>evt [::select-new-deficiency order-id (-> % futil/tval futil/parse-int)])}
          [ui/placeholder-select-item tr :none]
          (futil/for-frag [deficiency available-deficiencies]
            (cc/select-item {:text  (dropdown-text get-deficiency-description deficiency)
                             :value (:db/id deficiency)})))]]
      [:div.flex.flex-1.flex-col.lg:flex.row
       [:div.flex-1.mb-2
        [ui-rt/editor-legacy {:id                      "description"
                              :label-text              (tr [:deficiencies/description])
                              :initial-value           deficiency-description
                              :on-change               #(rf/dispatch-sync [::set-new-deficiency-data order-id :inspection.deficiency/description-from-order %])
                              :default-phrase-category (:group/phrase-category-inspections auth-group)
                              :authority-group-id      (:db/id auth-group)}]]
       [:div.flex-1
        [ui-rt/editor-legacy {:id                      "required-action"
                              :label-text              (tr [:inspection/required-action])
                              :initial-value           deficiency-required-action
                              :on-change               #(rf/dispatch-sync [::set-new-deficiency-data order-id :inspection.deficiency/required-action %])
                              :default-phrase-category (:group/phrase-category-inspections auth-group)
                              :authority-group-id      (:db/id auth-group)}]]]]]))

(defn list-table [title cols rows]
  [:div.mt-4
   [:h4.m-2 title]
   #_{:clj-kondo/ignore [:deprecated-var]}
   [ui-table/responsive-table {:tr    (<sub [:tr])
                               :class "mb-4"}
    cols
    (->> rows
         (map #(update % :opts merge {:class "border border-solid border-1 border-gray-300 mb-2"})))]])

(rf/reg-sub ::inspection-for-deficiency
  (fn [[_ deficiency-id]]
    (rf/subscribe [::entities/entity deficiency-id]))
  :-> :entity/parent)

(defn- deficiencies-list [deficiencies tr target-id order-id edit-permitted? workspace]
  [list-table
   (tr [:inspection/deficiencies])
   (cond-> [{:title (tr [:deficiencies/compliant])}
            {:title (tr [:inspection/inspection])}
            {:title (tr [:deficiencies/description]) :flex 2}
            {:title (tr [:inspection/required-action]) :opts {:class "pl-2"}}
            {:title (tr [:inspection/compliance-date]) :min-width "180px"}]
     (ff/enabled? :feature-flag.id/enhanced-order-templates)
     (conj {:title (tr [:inspection/compliant-by]) :min-width "180px"})
     :always
     (conj {:title "" :width "130px"}))
   (futil/for-all [deficiency deficiencies]
     (let [id           (:db/id deficiency)
           remark?      (:inspection.deficiency/remark? deficiency)
           cleared      (:inspection.deficiency/cleared deficiency)
           cleared?     (= (-> deficiency :domain/state) :inspection.deficiency.state/cleared)
           cleared-at   (if cleared ((<sub [::date-util/date-fn]) cleared) "-")
           comply-by    (:inspection.deficiency/comply-by-date deficiency)
           comply-by-at (if comply-by ((<sub [::date-util/date-fn]) comply-by) "-")
           inspection   (:entity/parent deficiency
                                        ;; draft order does not have entity here, so subscribe instead
                                        (<sub [::inspection-for-deficiency id]))
           lang         (<sub [:language])]
       {:key  id
        :cols [;; Compliant
               {:content (if remark? [insp-util/pill-text insp-util/transparent (tr [:deficiencies/remark])]
                             (if cleared?
                               [insp-util/pill-text insp-util/green (tr [:yes])]
                               [insp-util/pill-text insp-util/red (tr [:no])]))
                :opts    {:class "flex-wrap"}}
               {;; Inspection
                :content [:a.bx--link {:href (href/href :view/inspection-visit
                                                        {:inspection-id (:db/id inspection)
                                                         :workspace-id  (:workspace/id workspace)})}
                          (inspection-model/inspection-name inspection lang)]}
               {;; Description
                :content [deficiencies-v2/render-rich-text-description
                          "deficiency-description"
                          :description
                          (or (:inspection.deficiency/description-from-order deficiency)
                              (:inspection.deficiency/description deficiency))
                          nil
                          nil
                          tr
                          false]
                :opts    {:class "pr-2"}}
               {;; Required action
                :content [deficiencies-v2/render-rich-text-description
                          "deficiency-required-action"
                          :required-action
                          (:inspection.deficiency/required-action deficiency)
                          nil
                          nil
                          tr
                          false]}
               {;; Completed date
                :content cleared-at
                :opts    {:class "pr-2"}}
               (when (ff/enabled? :feature-flag.id/enhanced-order-templates)
                 {;; Comply by date
                  :content comply-by-at
                  :opts    {:class "pr-2"}})

               {;; Edit controls
                :content [:<>
                          (when edit-permitted?
                            (cc/button {:kind             :tertiary
                                        :size             :small
                                        :icon             i/trash
                                        :icon-position    :right
                                        :icon-description ""
                                        :on-click         #(>evt [::unlink-deficiency
                                                                  target-id
                                                                  order-id
                                                                  (:db/id deficiency)])}
                                       (tr [:unlink])))]}]}))])

(defn- deficiencies-part [{:keys [target-id
                                  auth-group
                                  order-id
                                  deficiencies
                                  edit-permitted?
                                  workspace]}]
  (let [tr     (<sub [:tr])
        adding (<sub [::deficiency-adding-open? order-id])]
    [:<>
     [deficiencies-list deficiencies tr target-id order-id edit-permitted? workspace]
     (when edit-permitted?
       (if adding
         [add-deficiencies tr order-id target-id auth-group]
         [subtle-button {:event [::open-deficiency-adding order-id]}
          (tr [:deficiencies/add-new])]))]))

(defn- linked-orders-list [{:keys [tr target-id order-id edit-permitted? lang]}]
  [list-table
   (tr [:inspection.order/linked-orders])
   [{:title (tr [:deficiencies/compliant]) :max-width "100px"}
    {:title (tr [:order/created]) :width "140px"}
    {:title (tr [:inspection.order/template-kind])}
    {:title "" :width "130px"}]
   (futil/for-all [order (<sub [::linked-order-entities order-id])]
     (let [id       (:db/id order)
           template (:inspection.order/order-template order)]
       {:key  id
        :cols [;; Compliant
               {:content (case (-> :domain/state order)
                           :inspection.order.state/cleared
                           [insp-util/pill-text insp-util/green (tr [:yes])]
                           :inspection.order.state/draft
                           [insp-util/pill-text insp-util/black (tr [:deficiencies/draft])]
                           [insp-util/pill-text insp-util/red (tr [:no])])}
               ;; Creation date
               {:content ((<sub [::date-util/date-fn]) (:entity/created order))
                :opts    {:class "flex-wrap"}}
               ;; Order type
               {:content (inspection-model/order-template-name template lang)
                :opts    {:class "flex-wrap"}}
               {;; Edit controls
                :content (when edit-permitted?
                           (cc/button {:kind             :tertiary
                                       :size             :small
                                       :icon             i/trash
                                       :icon-position    :right
                                       :icon-description ""
                                       :on-click         #(>evt [::unlink-order
                                                                 target-id
                                                                 order-id
                                                                 (:db/id order)])}
                                      (tr [:unlink])))}]}))])

(defn- linked-orders-part [{:keys [order-id target-id edit-permitted? lang]}]
  (let [tr               (<sub [:tr])
        linked-order-ids (<sub [::linked-order-ids order-id])]
    [:<>
     [linked-orders-list (util/mmap order-id
                                    edit-permitted?
                                    tr
                                    target-id
                                    lang)]
     (when edit-permitted?
       (if (<sub [::linked-order-adding-open? order-id])
         (let [selected (<sub [::new-linked-order-entity order-id])]
           [add-container {:title      (tr [:order/link-order])
                           :cancel-evt [::close-linked-order-adding order-id]
                           :add-evt    [::add-linked-order
                                        target-id
                                        order-id
                                        (:db/id selected)]
                           :disabled?  (nil? selected)}
            [ui-select/select {:id         (str order-id "-add-order")
                               :class-name "full-width-select mb-4"
                               :required   true
                               :values     (->> (<sub [::active-orders target-id])
                                                (remove #(-> % :db/id linked-order-ids))
                                                (remove #(-> % :db/id (= order-id))))
                               :val->str   (partial dropdown-text
                                                    #(inspection-model/order-name % lang))
                               :on-change  #(>evt [::select-linked-order
                                                   order-id
                                                   (:db/id %)])
                               :value      selected}]])
         [subtle-button
          {:event [::open-linked-order-adding order-id]}
          (tr [:order/link-order])]))]))

(defn other-items-list [{:keys [tr order-id edit-permitted? target-id]}]
  [list-table
   (tr [:inspection.order/other-items])
   [{:title (tr [:ordered/order]) :width "75px"}
    {:title (tr [:inspection.order.other/reference]) :width "150px"}
    {:title (tr [:inspection.order.other/description])}
    {:title "" :width "130px"}]
   (dnd/wrap-dnd
     {:id         (str "order-other-items-dnd-" order-id)
      :items      (<sub [::order-other-item-entities order-id])
      :on-reorder (fn [from to]
                    (>evt [:app.front.process/signal
                           target-id
                           [:process.signal/reorder-inspection-order-other-items
                            (merge {:id order-id}
                                   (dnd/ordering-tx-for-entity from to))]]))}
     (fn [{:keys [augment-draggable-props augment-target-props sorted]}]
       (->> sorted
            (map (fn [item]
                   {:key  (-> item :ordered/order inc)
                    :opts (augment-target-props {} item)
                    :cols [;; nr
                           {:content [:div
                                      (when (and edit-permitted?
                                                 ;; do not allow reordering for not-yet-saved
                                                 (not= order-id new-order-pseudo-id))
                                        [:span (-> {}
                                                   (augment-draggable-props item))
                                         (cc/icon {:icon        i/draggable
                                                   :description (tr [:reorder])})])
                                      [:span.pl-2
                                       (-> item :ordered/order inc)]]}
                           ;; description
                           ;; TODO edit controls would be nice, action supports it
                           {:content (:inspection.order.other/reference item)}
                           {:content [ui-rt/editor-legacy {:id            (str (-> item :ordered/order) "-item-required-action")
                                                           :initial-value (:inspection.order.other/description item)}]}
                           {;; Edit controls
                            :content (when edit-permitted?
                                       (cc/button {:kind             :tertiary
                                                   :size             :small
                                                   :icon             i/trash
                                                   :icon-position    :right
                                                   :icon-description ""
                                                   :on-click         #(>evt [::remove-other-item
                                                                             target-id
                                                                             order-id
                                                                             (or (:db/id item)
                                                                                 ;; when not yet created, use order
                                                                                 (:ordered/order item))])}
                                                  (tr [:delete])))}]}))
            doall)))])

(defn other-items-part [{:keys [order-id tr target-id edit-permitted? auth-group]}]
  [:<>
   [other-items-list (util/mmap order-id edit-permitted? tr target-id)]
   (when edit-permitted?
     (if (<sub [::other-item-adding-open? order-id])
       (let [description (<sub [::get-other-item-data
                                order-id
                                :inspection.order.other/description])
             reference   (<sub [::get-other-item-data
                                order-id
                                :inspection.order.other/reference])]
         [add-container {:title      (tr [:order/add-other-item])
                         :cancel-evt [::close-other-item-adding order-id]
                         :add-evt    [::add-other-item
                                      target-id
                                      order-id
                                      description
                                      reference]
                         :disabled?  (str/blank? description)}
          [ui/text-input {:id         (str order-id "-new-item-reference")
                          :label-text (tr [:inspection.order.other/reference])
                          :value      reference
                          :on-change  #(rf/dispatch-sync [::set-other-item-data
                                                          order-id
                                                          :inspection.order.other/reference
                                                          (futil/tval %)])}]
          [:div.my-2
           [ui-rt/editor-legacy {:id                      (str order-id "-new-item-required-action")
                                 :label-text              (tr [:inspection/required-action])
                                 :required?               true
                                 :class                   "my-2"
                                 :initial-value           description
                                 :on-change               #(rf/dispatch-sync [::set-other-item-data
                                                                              order-id
                                                                              :inspection.order.other/description
                                                                              %])
                                 :default-phrase-category (:group/phrase-category-inspections auth-group)
                                 :authority-group-id      (:db/id auth-group)}]]])
       [subtle-button
        {:event [::open-other-item-adding order-id]}
        (tr [:order/add-other-item])]))])


(defn notes-part [tr order-id auth-group on-change]
  [column-content (tr [:order.template.feature/notes])
   [ui-rt/editor-legacy (util/mmap {:initial-value      (<sub [::notes order-id])
                                    :authority-group-id (:db/id auth-group)
                                    :on-change          on-change})]
   true])

(defn- render-issued-to [tr lang target-id order-id editable? on-change-fn]
  (let [selected              (<sub [::issued-to-entities order-id])
        full-names-with-roles (some->> selected
                                       (map (partial party-model/full-name-with-roles lang))
                                       (str/join ", "))
        shared-select-opts    {:id         "issued-to-select"
                               :class-name "full-width-select"
                               :label-text (tr [:inspection/issued-to])
                               :values     (<sub [::parties target-id])
                               :val->str   (partial party-model/full-name-with-roles lang)}]
    (cond
      (<sub [::ws-subs/loading-config?])
      (cc/select-skeleton)
      editable?
      [:div.required-input
       (if (ff/enabled? :feature-flag.id/multi-select-issued-to)
         [ui-ms/multi-select
          (merge shared-select-opts
                 {:displayed-text (or full-names-with-roles
                                      (tr [:select-option]))
                  :value          selected
                  :on-change      #(on-change-fn :inspection.order/issued-to (set (map :db/id %)))})]
         [ui-select/select
          (merge shared-select-opts
                 {:allow-empty? false
                  :required     true
                  :value        (-> selected first)
                  :on-change    #(on-change-fn :inspection.order/issued-to #{(:db/id %)})})])]
      :else
      [column-content (tr [:inspection/issued-to]) full-names-with-roles true])))

(defn order-editor-fields [{:keys [order-id
                                   on-change
                                   deficiencies
                                   auth-group
                                   edit-permitted?
                                   target-id
                                   workspace
                                   tr]}]
  (let [lang      (<sub [:language])
        template  (<sub [::template order-id])
        target    (<sub [::entities/entity target-id])
        templates (<sub [::order-template-entities target])
        features  (<sub [::features order-id])]
    [:<>
     [:div.mb-6
      (if edit-permitted?
        [ui-select/select {:id           "order-template-kind"
                           :val->str     #(inspection-model/order-template-name % lang)
                           :class-name   "full-width-select"
                           :allow-empty? false
                           :required     true
                           :values       templates
                           :value        (p/find-first templates {:db/id template})
                           :on-change    #(on-change :inspection.order/order-template (:db/id %))
                           :label-text   (tr [:inspection.order/template-kind])}]
        [:h4 (inspection-model/order-template-name template lang)])]

     [:div.mb-6.flex.flex-col.md:flex-row
      [:div.flex-1.md:mr-4
       [render-issued-to tr lang target-id order-id edit-permitted? on-change]]
      [column-content (tr [:inspection/permit-no]) (:workspace/municipal-case-id workspace)]]

     [:div.mb-6.flex.flex-col.md:flex-row
      (when (features :order.template.feature/due-date)
        [:div.flex-1.md:mr-4
         [render-compliant-by-date-picker
          tr
          (<sub [::compliant-by-date order-id])
          (partial on-change :inspection.order/compliant-by-date)
          edit-permitted?]])
      [:div.flex-1
       [render-additional-address-information-text-field
        tr
        (<sub [::address-info order-id])
        (comp (partial on-change :inspection.order/additional-address-information)
              futil/tval)
        edit-permitted?]]]

     (when (features :order.template.feature/notes)
       [notes-part tr order-id auth-group (when edit-permitted? (partial on-change :inspection.order/notes))])

     (when (features :order.template.feature/linked-deficiencies)
       [deficiencies-part (util/mmap order-id
                                     target-id
                                     auth-group
                                     deficiencies
                                     edit-permitted?
                                     workspace)])

     (when (features :order.template.feature/linked-orders)
       [linked-orders-part (util/mmap order-id
                                      tr
                                      edit-permitted?
                                      target-id
                                      lang)])

     (when (features :order.template.feature/other-items)
       [other-items-part (util/mmap order-id
                                    tr
                                    edit-permitted?
                                    target-id
                                    auth-group)])]))

(defn- render-order-editor [tr auth-group target-id workspace]
  [:div.p-4.border.border-solid.border-gray-400.bg-gray-200.animation-appear-slide-down
   [:header.mb-4.flex.justify-between
    [:h2.mb-0.text-base (tr [:inspection/add-new-order])]]
   [order-editor-fields (util/mmap {:order-id        new-order-pseudo-id
                                    :edit-permitted? true
                                    :deficiencies    (<sub [::new-order-field
                                                            :inspection.order/deficiencies])
                                    :on-change       (fn [key val]
                                                       (>evt [::set-create-field key val]))}
                                   auth-group
                                   target-id
                                   workspace
                                   tr)]
   [:div.flex.justify-end
    [ui-action-buttons/save-cancel-buttons
     (util/mmap {:on-cancel      #(>evt [::close-editor])
                 :on-save        #(>evt [::create target-id])
                 :save-disabled? (<sub [::editor-create-disabled?])
                 :save-tr        :deficiencies/add-and-close}
                tr)]]])


(defn- acknowledgement-block [{:keys [accepted?
                                      order
                                      tr
                                      acknowledgement
                                      order-id
                                      target-id]}]
  [:div.mt-6
   [:<>
    (when accepted?
      [:div.my-2
       [acknowledge/acknowledged tr acknowledgement]])
    [:div.flex.items-center
     [acknowledge/file-list tr order]]]
   (when (and (not (inspection-model/acknowledged-by-user? acknowledgement))
              (<sub [:app.front.process/signal-permitted? target-id
                     [:process.signal/upload-signed-order {:order-id order-id}]]))
     [:div.my-3
      [upload/upload-button "acknowledgement-upload"
       {:attach-file-fn  (fn [file-id filename content-type _]
                           (>evt [:app.front.process/signal
                                  target-id
                                  [:process.signal/upload-signed-order
                                   {:file-id      file-id
                                    :filename     filename
                                    :content-type content-type
                                    :order-id     order-id}]
                                  {:on-success [::acknowledge/order-acknowledged]}]))
        :button-i18n-key (if accepted? :order/replace-signed-order :order/upload-signed-order)
        :accept-types    [".pdf" "application/pdf"]}]])])

(defn issued [tr order]
  [:<>
   [cc/icon {:icon        i/envelope
             :fill        "green"
             :description (tr [:order/created])}]
   [:span.ml-2
    (tr [:order/created])
    " "
    ((<sub [::date-util/date-time-fn]) (-> order :inspection.order/issue-date))]])

(rf/reg-sub ::issue-order-disabled-reason
  (fn [[_ order-id]]
    [(rf/subscribe [::order-editing-in-progress? order-id])
     (rf/subscribe [::invalid-order-reason order-id])])
  (fn [[editing? invalid-order-reason] _]
    (if editing?
      :inspection/issue-order-editing-in-progress
      invalid-order-reason)))

(defn- issue-block [{:keys [create-permitted?
                            draft?
                            order
                            target-id
                            tr]}]
  (let [order-id (:db/id order)]
    [:div.mt-6
     (if draft?
       (when create-permitted?
         (if (<sub [::ws-subs/loading-config?])
           (cc/button-skeleton)
           (let [disabled-reason (<sub [::issue-order-disabled-reason order-id])]
             [:<>
              (when disabled-reason
                [ui/warning (tr [disabled-reason])])
              [ui/modal-confirmation-button
               {:tr                  tr
                :id                  "issue-order"
                :disabled?           (boolean disabled-reason)
                :trigger-button-text (tr [:inspection/issue-order])
                :trigger-button-opts {:kind             :primary
                                      :icon             i/envelope
                                      :icon-position    :right
                                      :icon-description ""}
                :modal-title         (tr [:inspection/issue-order])
                :on-yes-click        #(>evt [::issue-order target-id order-id])}
               (tr [:inspection/issue-order-confirmation])]])))
       [:div.my-2
        [issued tr order]])]))

(defn- expanded-content [{:keys [tr
                                 order
                                 create-permitted?
                                 edit-permitted?
                                 draft?
                                 active?
                                 ready-to-close?
                                 auth-group
                                 workspace
                                 target-id]}]
  (let [order-id        (:db/id order)
        ;; Only one acknowledgements should reference the order
        acknowledgement (-> order :order.acknowledgement/_order first)
        accepted?       (inspection-model/acknowledgement-accepted? acknowledgement)]
    [:div.p-4.border.border-solid.border-gray-100
     [order-editor-fields (util/mmap {:deficiencies (:inspection.order/deficiencies order)
                                      :on-change    (fn [field val]
                                                      (>evt [::set-order-field
                                                             order-id
                                                             target-id
                                                             field
                                                             val]))}
                                     order-id
                                     auth-group
                                     edit-permitted?
                                     target-id
                                     workspace
                                     tr)]

     (when (and create-permitted? active?)
       [ui/modal-confirmation-button
        {:tr                  tr
         :id                  "close-order"
         :disabled?           (not ready-to-close?)
         :trigger-button-text (tr [:inspection/close-order])
         :trigger-button-opts {:kind             :primary
                               :icon             i/check
                               :icon-position    :right
                               :icon-description (tr [:inspection/close-order])}
         :modal-title         (tr [:inspection/close-order])
         :on-yes-click        #(>evt [::clear-order order-id target-id])}
        (tr [:inspection/close-order-confirmation])])

     [issue-block (util/mmap create-permitted?
                             draft?
                             order
                             tr
                             order-id
                             target-id)]
     (when (not draft?)
       [acknowledgement-block (util/mmap accepted?
                                         order
                                         tr
                                         acknowledgement
                                         order-id
                                         target-id)])]))

(defn- render-orders [{:keys [active-orders tr target-id create-permitted? auth-group workspace lang]}]
  (when (not-empty active-orders)
    (let [format-date (<sub [::date-util/date-fn])]
      #_{:clj-kondo/ignore [:deprecated-var]}
      [ui-table/responsive-table {:tr          tr
                                  :class       "mb-4"
                                  :expandable? true}
       [{:title ""}
        {:title (tr [:deficiencies/compliant]) :max-width "100px"}
        {:title (tr [:inspection/issued-to])}
        {:title (tr [:inspection/issued-by]) :opts {:class "pl-2"}}
        {:title (tr [:deficiencies/compliance-date]) :min-width "180px"}
        {:title (tr [:inspection/compliant-by]) :min-width "180px"}
        {:title "" :width "130px"}]
       (->> active-orders
            (map (fn [order]
                   (let [id                     (:db/id order)
                         edit-permitted?        (<sub [:app.front.process/signal-permitted?
                                                       target-id
                                                       [:process.signal/edit-inspection-order {:id id}]])
                         deficiencies-done?     (->> (:inspection.order/deficiencies order)
                                                     (every? #(or (du/in-state? :inspection.deficiency.state/cleared %)
                                                                  (:inspection.deficiency/remark? %))))
                         linked-orders-cleared? (->> (:inspection.order/linked-orders order)
                                                     (every? (du/in-state-fn :inspection.order.state/cleared)))
                         ready-to-close?        (and deficiencies-done? linked-orders-cleared?)
                         draft?                 (= :inspection.order.state/draft (-> :domain/state order))
                         cleared?               (= :inspection.order.state/cleared (-> :domain/state order))
                         active?                (= :inspection.order.state/active (-> :domain/state order))
                         cleared                (-> order :inspection.order/cleared)
                         cleared-at             (if cleared (format-date cleared) "-")
                         template               (:inspection.order/order-template order)]
                     {:key              id
                      :opts             {:class (futil/cs "my-3 mb-4 border-2"
                                                          (when draft? "border-dashed border-gray-400")
                                                          (when (not draft?) "bg-gray-100"))}
                      :expanded-content [expanded-content (util/mmap tr
                                                                     order
                                                                     create-permitted?
                                                                     edit-permitted?
                                                                     draft?
                                                                     auth-group
                                                                     workspace
                                                                     target-id
                                                                     active?
                                                                     ready-to-close?)]
                      :cols             [{:content (inspection-model/order-template-name template lang)
                                          :opts    {:class "flex-wrap"}}
                                         ;; Compliant
                                         {:content (cond
                                                     cleared?
                                                     [insp-util/pill-text insp-util/green (tr [:yes])]
                                                     draft?
                                                     [insp-util/pill-text insp-util/black (tr [:deficiencies/draft])]
                                                     :else
                                                     [insp-util/pill-text insp-util/red (tr [:no])])}
                                         {;; Issued to
                                          :content (->> order
                                                        :inspection.order/issued-to
                                                        (map #(party-model/simple-name % lang))
                                                        (str/join ", "))
                                          :opts    {:class "pr-2"}}
                                         {;; Description
                                          :content (user-model/full-name (:entity/creator order))
                                          :opts    {:class "pr-2"}}
                                         {;; Compliance date
                                          :content cleared-at}
                                         {;; Compliant by date
                                          :content (-> (:inspection.order/compliant-by-date order) format-date)}
                                         {;; Edit controls
                                          :content [:<>
                                                    (when create-permitted?
                                                      [ui/modal-confirmation-button
                                                       {:tr                  tr
                                                        :id                  "delete-order"
                                                        :trigger-button-text (tr [:delete])
                                                        :trigger-button-opts {:kind             :tertiary
                                                                              :size             :small
                                                                              :icon             i/trash
                                                                              :icon-position    :right
                                                                              :icon-description ""}
                                                        :modal-title         (tr [:inspection/delete-order])
                                                        :on-yes-click        #(>evt [::remove-order target-id id])}
                                                       (tr [:inspection/delete-order-confirmation])])]}]})))
            doall)])))

(defn render-orders-list [{:keys [tr workspace target-entity orders? create-permitted?]}]
  (let [target-id           (:db/id target-entity)
        auth-group          (:domain/authority-group workspace)
        creating-new-order? (<sub [::creating-new-order?])
        active-orders       (<sub [::active-orders target-id])
        lang                (<sub [:language])]
    [:div.orders
     (when create-permitted?
       [:div.mb-2
        (when creating-new-order?
          [render-order-editor tr auth-group target-id workspace])])
     (if orders?
       [render-orders (util/mmap active-orders
                                 tr
                                 target-id
                                 create-permitted?
                                 auth-group
                                 workspace
                                 lang)]
       (when (not creating-new-order?)
         [:div.mt-2 (tr [:inspection/no-orders])]))
     (when (and (not creating-new-order?) create-permitted?)
       [:div.mt-4
        [ui-table/add-new-button
         (assoc (util/mmap tr) :on-click (fn []
                                           (>evt [::initialize-new-order])
                                           (>evt [::set-create-field :create-open? true])))]])]))


(defn section [{:keys [tr workspace execution target-entity] :as state}]
  (let [target-entity       (or target-entity execution)
        target-id           (:db/id target-entity)
        orders?             (<sub [::orders? target-id])
        create-permitted?   (<sub [:app.front.process/signal-permitted?
                                   target-id
                                   [:process.signal/create-inspection-order]])
        ui-improvements?    (<sub [::ff/enabled? :feature-flag.id/inspection-ui-improvements])
        creating-new-order? (<sub [::creating-new-order?])
        show-section?       (if ui-improvements?
                              (or orders? creating-new-order?)
                              (or orders? create-permitted?))]
    (when show-section?
      [ws-section/section
       target-entity
       :application-orders
       state
       :verdict.section.type/orders
       false
       [:<> {:key "orders"}
        [render-orders-list (util/mmap tr
                                       workspace
                                       target-entity
                                       orders?
                                       create-permitted?)]]])))
